package com.xtream.data_kmp.util.extension


import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.json.Json
import kotlin.math.ceil
import kotlin.time.Instant

class StringExt

/**
 * Converts timestamp string to yyyy-MM-dd format using kotlinx-datetime
 */
fun String.stringDateFromTimeStamp(): String {
    return try {
        val instant = Instant.fromEpochSeconds(this.toLong())
        val localDate = instant.toLocalDateTime(TimeZone.currentSystemDefault()).date
        localDate.toString() // Returns "YYYY-MM-DD" by default
    } catch (e: Exception) {
        this
    }
}

fun String.formatTime(): String {
    if (this.isEmpty()) return ""
    val parts = split(":")
    if (parts.size < 2) return this
    val hours = parts[0].toIntOrNull() ?: 0
    val minutes = parts[1].toIntOrNull() ?: 0

    return "${hours}h ${minutes}min"
}

fun String.getMacFormatedString(): String {
    val value = this.trim().filter { it.isDigit() || it.isLetter() }
    val macAddressLength = 12
    val mac = when {
        value.length >= macAddressLength -> {
            value.substring(0, macAddressLength)
        }
        else -> {
            if (value.isEmpty()) ""
            else {
                val neededLength = macAddressLength.toDouble() / value.length
                val repeatCount = ceil(neededLength).toInt()
                value.repeat(repeatCount).substring(0, 12)
            }
        }
    }
    return mac.chunked(2).joinToString(":")
}

/**
 * Replaced Android URI with standard string manipulation for KMP compatibility
 */
fun String.getFileExtension(): String {
    if (this.isEmpty()) return ""
    // Remove query parameters if present
    val path = this.substringBefore('?').substringBefore('#')
    val lastIndex = path.lastIndexOf('.')
    return if (lastIndex != -1 && lastIndex < path.length - 1) {
        path.substring(lastIndex + 1).lowercase()
    } else {
        ""
    }
}

fun String.formatToMovieTitle(): String? {
    if (this.isEmpty()) return null
    return this
        .replace(Regex("^[A-Z]{2}:\\s*"), "")
        .replace(Regex("\\s+\\(.*?\\)"), "")
        .replace(Regex("\\[.*?]"), "")
        .trim()
}

fun String?.addTMDBPrefixImageURL(): String? {
    return if (this.isNullOrEmpty()) null else "https://image.tmdb.org/t/p/original/$this"
}

/**
 * Formats Long (ms) to HH:mm:ss
 */
fun Long.formatAsTime(): String {
    val instant = Instant.fromEpochMilliseconds(this)
    val dt = instant.toLocalDateTime(TimeZone.UTC)
    return "${dt.hour.pad()}:${dt.minute.pad()}:${dt.second.pad()}"
}

/**
 * Formats Long (ms) to yyyy/MM/dd HH:mm
 */
fun Long.formatAsDateTime(): String {
    val instant = Instant.fromEpochMilliseconds(this)
    val dt = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    return "${dt.year}/${dt.monthNumber.pad()}/${dt.dayOfMonth.pad()} ${dt.hour.pad()}:${dt.minute.pad()}"
}

// Helper for padding numbers (e.g., 9 -> "09")
private fun Int.pad(): String = this.toString().padStart(2, '0')

// JSON Extensions
fun String.toLiveStreamOrNull() = toTypeOrNull<LiveStream?>()
fun String.toVodStreamOrNull() = toTypeOrNull<VodStream?>()
fun String.toSeriesStreamOrNull() = toTypeOrNull<SeriesStream?>()
fun String.toLiveCategoryOrNull() = toTypeOrNull<LiveCategory?>()
fun String.toVodCategoryOrNull() = toTypeOrNull<VodCategory?>()
fun String.toSeriesCategoryOrNull() = toTypeOrNull<SeriesCategory?>()

inline fun <reified T> String.toTypeOrNull(): T? {
    val json = Json {
        ignoreUnknownKeys = true
        isLenient = true
        encodeDefaults = false
    }
    return try {
        json.decodeFromString<T>(this)
    } catch (e: Exception) {
        null
    }
}

// commonMain
fun String?.formattedRating(): String {
    if (this == null) return ""
    val doubleValue = this.toDoubleOrNull() ?: return this

    // Multiplies by 10, rounds to nearest integer, then divides by 10
    // e.g., 8.46 -> 84.6 -> 85 -> 8.5
    val rounded = (doubleValue * 10.0).let { kotlin.math.round(it) / 10.0 }

    return rounded.toString()
}